import { render, staticRenderFns } from "./OrderedTableForSales.vue?vue&type=template&id=49fc5ceb&"
import script from "./OrderedTableForSales.vue?vue&type=script&lang=js&"
export * from "./OrderedTableForSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports